import Typography from '@mui/material/Typography';
import { useMemo } from 'react';

import { useDataProvider } from '@work4all/data/lib/hooks/data-provider';

import { TravelCostInvoiceKindTransportCost } from '@work4all/models/lib/Classes/TravelCostInvoiceKindTransportCost.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { Tooltip } from '../../tooltip/Tooltip';
import { ListEntityPicker } from '../components/list-entity-picker/ListEntityPicker';
import { IPickerProps } from '../types';

export type IReceiptKindTravelCostPickerProps<TMultiple extends boolean> =
  IPickerProps<TravelCostInvoiceKindTransportCost, TMultiple>;

export function ReceiptKindTravelCostPicker<TMultiple extends boolean>(
  props: IReceiptKindTravelCostPickerProps<TMultiple>
) {
  const { data, ...rest } = props;

  const allFields = useMemo(() => {
    return { ...FIELDS, ...data };
  }, [data]);

  const requestData = useMemo<DataRequest>(() => {
    return {
      entity: Entities.travelCostInvoiceKindTransportCost,
      data: allFields,
      completeDataResponse: true,
    };
  }, [allFields]);

  const response = useDataProvider(requestData);

  const dataset = useMemo(() => {
    return {
      total: response.data.length,
      loading: false,
      fetchMore: () => Promise.resolve(),
      refetch: () => Promise.resolve(null),
      data: response.data,
    };
  }, [response.data]);

  return (
    <ListEntityPicker
      entity={Entities.travelCostInvoiceKindTransportCost}
      data={allFields}
      fixedDataSet={dataset}
      filterBy="name"
      sortBy="name"
      {...rest}
      renderItemContent={(projectKind) => (
        <Tooltip
          title={projectKind.name}
          showOnlyOnOverflow
          enterNextDelay={1000}
        >
          <Typography variant="body2" noWrap>
            {projectKind.name}
          </Typography>
        </Tooltip>
      )}
    />
  );
}

const FIELDS: TravelCostInvoiceKindTransportCost = {
  id: null,
  name: null,
  ledgerAccount1: null,
  ledgerAccount2: null,
  ledgerAccount3: null,
  vat1: null,
  vat2: null,
  vat3: null,
  enumReceiptKindTravelCosts: null,
  ledgerAccountEntity1: {
    id: null,
    name: null,
    number: null,
  },
  ledgerAccountEntity2: {
    id: null,
    name: null,
    number: null,
  },
  ledgerAccountEntity3: {
    id: null,
    name: null,
    number: null,
  },
  taxKeyEntity1: {
    id: null,
    taxKeyValue: null,
    vat: null,
  },
  taxKeyEntity2: {
    id: null,
    taxKeyValue: null,
    vat: null,
  },
  taxKeyEntity3: {
    id: null,
    taxKeyValue: null,
    vat: null,
  },
};
